runOnLoad "Organizations", ["new", "create", "edit", "update"], ->

  setModeVisibility = (field, setFocus) ->
    # Get the input for this field.
    $input = $("input[name='organization[#{field}_mode]']")
    # Find the selection lines for this field.
    $selections = $input.closest(".form-field").find(".permission-line.selection")
    # Get the mode that is currently selected for this field.
    mode = $input.filter(":checked").val()
    # Disable all of the selects for this field.
    # v4 select2 reflects the underlying <select>'s disabled property, so setting
    # it is enough — the v3 .select2("disable") method was removed.
    $selections.hide().find("select,input,textarea").hide().prop("disabled", true)
    # Enable just the select we're using.
    UI.setupSelects($selections.filter(".#{mode}").show().find("select,input,textarea").show().removeAttr("disabled").filter("select"))
    # Focus on the input field, if there is one.
    $selections.find("input:visible").eq(0).focus() if setFocus

  bindVisibilityOnChange = (field) ->
    setModeVisibility field, false
    $("input[name='organization[#{field}_mode]']").change -> setModeVisibility(field, true)

  for field in [ "virtual_mta", "bounce_email", "url_domain", "speed", "email", "quota", "special_sending_rule", "remote_database_connection" ]
    bindVisibilityOnChange field
